import SchoolsAdapter from './base';

export default class School extends SchoolsAdapter {
  modelNamePlural = 'schools';
}
